export default {"src":"/_next/static/media/calendarIconWhite.49428fd1.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};